const style = {
  plus: {
    position: 'relative',
    bottom: '-8px',
  },
  plusSend: {
    position: 'relative',
    bottom: '4px',
  },
  textField: {
    width: '95%',
  },
}

export default style
